// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__n0VQy","error":"Popup_error__-YIOw","breathing":"Popup_breathing__aVgwy"};